export const listBasicHorses = /* GraphQL */ `
  query ListHorses(
    $id: ID
    $filter: ModelHorseFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listHorses(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        name
        nickname
        personId
        ownerId
        ownerName
        barnName
        barnId
        dateOfBirth
        height
        fraction
        createdOn
        updatedOn
      }
      nextToken
    }
  }
`;

export const horsesByNameWithOnlyBasicDetails = /* GraphQL */ `
  query HorsesByName(
    $name: String!
    $createdOn: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelHorseFilterInput
    $limit: Int
    $nextToken: String
  ) {
    horsesByName(
      name: $name
      createdOn: $createdOn
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        nickname
        personId
        ownerId
        ownerName
        barnName
        barnId
        dateOfBirth
        height
        fraction
        createdOn
        updatedOn
      }
      nextToken
    }
  }
`;

export const horsesByPersonIdByNameWithOnlyBasicDetails = /* GraphQL */ `
  query HorsesByPersonIdByName(
    $personId: String!
    $name: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelHorseFilterInput
    $limit: Int
    $nextToken: String
  ) {
    horsesByPersonIdByName(
      personId: $personId
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        personId
        ownerId
        ownerName
        barnName
        barnId
        breed
        sex
        height
        fraction
        cogginsNumber
        cogginsDate
        cogginsState
        coggins {
          title
          description
          originalExtension
          dateUploaded
          url
          bucket
          region
          key
        }
        createdOn
        updatedOn
      }
      nextToken
    }
  }
`;

export const horsesByBarnIdByNameWithOnlyBasicDetails = /* GraphQL */ `
  query HorsesByBarnIdByName(
    $barnId: ID!
    $name: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelHorseFilterInput
    $limit: Int
    $nextToken: String
  ) {
    horsesByBarnIdByName(
      barnId: $barnId
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        personId
        ownerId
        ownerName
        barnName
        barnId
        breed
        sex
        height
        fraction
        cogginsNumber
        cogginsDate
        cogginsState
        coggins {
          title
          description
          originalExtension
          dateUploaded
          url
          bucket
          region
          key
        }
        createdOn
        updatedOn
      }
      nextToken
    }
  }
`;